import http from '@/utils/request';

// 获取主体信息
export const getQueryBodyList = (data = {}) => {
  return http.post({
    url: '/counting/config/queryBodyList',
    data,
  });
};

/** ******************* 对账主体 ******************* */

// 对账主体列表
export const getConfigList = (data = {}) => {
  return http.post({
    url: '/counting/config/bopList',
    data,
  });
};

// 删除对账主体
export const delConfig = (data = {}) => {
  return http.post({
    url: '/counting/config/del',
    data,
  });
};

// 新增/编辑对账主体
export const configOperation = (data = {}) => {
  return http.post({
    url: '/counting/config/operation',
    data,
  });
};

/** ******************* 对账-收款 ******************* */

// 对账-收款列表
export const getTradeReceiptList = (data = {}) => {
  return http.post({
    url: '/counting/tradeReceipt/bopList',
    data,
  });
};

// 对账-收款明细列表
export const getTradeReceiptDetailList = (data = {}) => {
  return http.post({
    url: '/counting/tradeReceipt/detailList',
    data,
  });
};

// 对账-收款明细列表-收款交易-抬头统计
export const getDetailLookUpStat = (data) => {
  return http.post({
    url: '/counting/tradeReceipt/detailLookUpStat',
    data,
  });
};
/** ******************* 对账-代付 ******************* */

// 对账-代付列表
export const getTradePayList = (data = {}) => {
  return http.post({
    url: '/counting/trade_payment/bopList',
    data,
  });
};

// 对账-代付明细列表
export const getTradePayDetailList = (data = {}) => {
  return http.post({
    url: '/counting/trade_payment/detailList',
    data,
  });
};

// 对账-代付明细导出
export const TRADE_PAY_REPORT = '/counting/trade_payment/report';


// 对账-对账付款交易-抬头统计
export const getPayDetailLookUpStat = (data) => {
  return http.post({
    url: '/counting/trade_payment/detailLookUpStat',
    data,
  });
};

/** ************************************** */

// 重新取数
export const getRecounting = (data = {}) => {
  return http.post({
    url: '/counting/common/reCounting',
    data,
  });
};

// 对账明细下载
export const getFileDownloadUrl = (data = {}) => {
  return http.post({
    url: '/counting/yibao/common/download',
    data,
  });
};

// 对账确认
export const confirmTrade = (data = {}) => {
  return http.post({
    url: '/counting/yibao/trade/confirm',
    data,
  });
};



/** ******************* 异常处理-收款 ******************* */

// 收款轧差列表
export const getReceiptDiffList = (data = {}) => {
  return http.post({
    url: '/counting/yibao/trade/receipt/diff/bopList',
    data,
  });
};

/** ******************* 异常处理-代付 ******************* */

// 对账轧差列表
export const getPayDiffList = (data = {}) => {
  return http.post({
    url: '/counting/yibao/pay/diff/bopList',
    data,
  });
};

// 对账轧差处理
export const updateDiff = (data = {}) => {
  return http.post({
    url: '/counting/yibao/trade/diff/update',
    data,
  });
};

// 渠道手续费日报表-列表
export const getChannelFeeReport = (data) => {
  return http.post({
    url: '/counting/channelFeeReport/bopList',
    data,
  });
};
